import React from "react";
import { InfoIcon } from "@sscs/ui/icons";
import FormPanel from "../FormPanel/FormPanel";
import OrgRoleMappingFields from "../OrgRoleMappingFields/OrgRoleMappingFields";
import styles from "./orgRoleMapping.module.scss";

function OrgRoleMapping(): React.JSX.Element {
  return (
    <FormPanel
      title="Organization role mapping"
      byline="At least one group must be assigned to the organization administrator role"
      className={styles["form-panel-wide"]}
    >
      <small className={styles["info-flex"]}>
        <InfoIcon />
        Group names are required and must be unique.
      </small>
      <OrgRoleMappingFields />
    </FormPanel>
  );
}

export default OrgRoleMapping;
